import {
  WORK_ORDERS_DETAILS_PURCHASE_ORDER_CANCEL,
  WORK_ORDERS_DETAILS_PURCHASE_ORDER_DOCUMENT_FILE_SET,
  WORK_ORDERS_DETAILS_PURCHASE_ORDER_DOCUMENT_REMOVE,
  WORK_ORDERS_DETAILS_PURCHASE_ORDER_EDIT_SET,
  WORK_ORDERS_DETAILS_PURCHASE_ORDER_NUMBER_SET,
  WORK_ORDERS_DETAILS_PURCHASE_ORDER_UPDATE,
} from 'actions/admin/work-orders/action-types';
import { showErrorMessage } from 'actions/messages';
import { workOrdersApi } from 'services/api/work-orders-api';
import { updateWorkOrderAttribute } from 'actions/admin/work-orders/work-orders';

export function cancelValues(workOrder) {
  return {
    type: WORK_ORDERS_DETAILS_PURCHASE_ORDER_CANCEL,
    payload: workOrder,
  };
}

export function removeDocument() {
  return {
    type: WORK_ORDERS_DETAILS_PURCHASE_ORDER_DOCUMENT_REMOVE,
  };
}

export function saveValuesRequest(workOrderId, file, number) {
  return (dispatch) => {
    return workOrdersApi
      .updatePurchaseOrder(workOrderId, file, number)
      .then((response) => {
        if (response.ok) {
          dispatch(
            updateWorkOrderAttribute(response.workOrder, 'purchase_order_doc')
          );
          dispatch(
            updateWorkOrderAttribute(response.workOrder, 'purchase_order')
          );
          dispatch(updateValues(response.workOrder));
        } else {
          dispatch(showErrorMessage(response.errors));
        }

        return response;
      });
  };
}

export function setDocumentFile(file) {
  return {
    type: WORK_ORDERS_DETAILS_PURCHASE_ORDER_DOCUMENT_FILE_SET,
    payload: file,
  };
}

export function setEdit(value) {
  return {
    type: WORK_ORDERS_DETAILS_PURCHASE_ORDER_EDIT_SET,
    payload: value,
  };
}

export function setNumber(value) {
  return {
    type: WORK_ORDERS_DETAILS_PURCHASE_ORDER_NUMBER_SET,
    payload: value,
  };
}

export function updateValues(workOrder) {
  return {
    type: WORK_ORDERS_DETAILS_PURCHASE_ORDER_UPDATE,
    payload: workOrder,
  };
}



// WEBPACK FOOTER //
// ./src/actions/admin/work-orders/details/purchase-order.js